<template>
  <MetricCard
    apiEndpoint="/tiktok/cost-per-click"
    metricName="CPC"
    :formatData="formatCPC"
    srcName="TikTok"
  />
</template>

<script setup>
import MetricCard from '@/components/MetricCard.vue';

const formatCPC = (data) => '₹' + data.data;
</script>
